import React from 'react';
import { Link } from 'react-router-dom';
import './PublicPages.css';

const About = () => {
  const values = [
    {
      icon: '⚖️',
      title: 'Justice',
      description: 'Ensuring fair and transparent judicial processes for all.',
    },
    {
      icon: '🔒',
      title: 'Security',
      description: 'Protecting sensitive legal information with advanced security measures.',
    },
    {
      icon: '⚡',
      title: 'Efficiency',
      description: 'Streamlining court operations to reduce delays and improve service delivery.',
    },
    {
      icon: '🌐',
      title: 'Accessibility',
      description: 'Making court services accessible to all citizens through digital platforms.',
    },
  ];

  const team = [
    {
      role: 'Development Team',
      description: 'Dedicated developers working on continuous improvement and innovation.',
    },
    {
      role: 'Legal Advisors',
      description: 'Expert legal professionals ensuring compliance and best practices.',
    },
    {
      role: 'System Administrators',
      description: 'Technical experts maintaining system reliability and security.',
    },
  ];

  return (
    <div className="about-page">
      <div className="page-header">
        <div className="container">
          <h1>About Us</h1>
          <p>Transforming the judicial system through technology</p>
        </div>
      </div>

      <div className="container">
        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            The e-Court Management System is designed to modernize and streamline court operations,
            making the judicial process more efficient, transparent, and accessible. Our mission is to
            leverage technology to improve case management, reduce paperwork, and enhance the overall
            experience for judges, advocates, and citizens.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Vision</h2>
          <p>
            We envision a future where all court operations are digitized, making justice more accessible
            and efficient. Through continuous innovation and improvement, we aim to set new standards
            in judicial technology and serve as a model for court management systems worldwide.
          </p>
        </section>

        <section className="about-section">
          <h2>Core Values</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="about-section">
          <h2>Key Features</h2>
          <div className="features-list">
            <div className="feature-item">
              <strong>Case Management:</strong> Comprehensive case registration and tracking system
            </div>
            <div className="feature-item">
              <strong>Hearing Scheduling:</strong> Efficient hearing management with automated reminders
            </div>
            <div className="feature-item">
              <strong>Document Management:</strong> Secure document storage with role-based access
            </div>
            <div className="feature-item">
              <strong>Judgment System:</strong> Digital judgment entry and order management
            </div>
            <div className="feature-item">
              <strong>Public Access:</strong> Case status tracking and cause list viewing for citizens
            </div>
            <div className="feature-item">
              <strong>Reporting:</strong> Comprehensive analytics and performance reports
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Our Team</h2>
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card">
                <h3>{member.role}</h3>
                <p>{member.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="about-cta">
          <h2>Get Involved</h2>
          <p>Join us in transforming the judicial system through technology</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary-large">
              Contact Us
            </Link>
            <Link to="/services" className="btn-secondary-large">
              View Services
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;

